import styled from 'styled-components';
import { TableRow } from 'components/Table';

/** Grid-template-columns constants for parent chain rows */
export const PARENT_COLUMNS_SINGLE = `
  minmax(24px, 0.2fr) minmax(70px, 1fr) minmax(140px, 2fr) minmax(64px, 0.8fr) minmax(64px, 1fr)
  minmax(48px, 0.7fr)
  minmax(64px, 1fr)
  minmax(64px, 1fr)
  minmax(72px, 1fr)
  minmax(48px, 0.7fr)
  minmax(80px, 1.2fr)
  minmax(54px, 0.8fr)`;

export const PARENT_COLUMNS_MULTI = `
  minmax(24px, 0.2fr) minmax(64px, 0.9fr) minmax(56px, 0.8fr) minmax(120px, 1.8fr) minmax(48px, 0.6fr) minmax(60px, 0.9fr)
  minmax(48px, 0.7fr)
  minmax(56px, 0.8fr)
  minmax(56px, 0.8fr)
  minmax(48px, 0.7fr)
  minmax(80px, 1.2fr)
  minmax(54px, 0.8fr)`;

export const PARENT_COLUMNS_MULTI_NO_DATE = `
  minmax(24px, 0.2fr) minmax(60px, 0.9fr) minmax(140px, 2fr) minmax(52px, 0.7fr) minmax(64px, 1fr)
  minmax(52px, 0.7fr)
  minmax(60px, 0.9fr)
  minmax(60px, 0.9fr)
  minmax(52px, 0.7fr)
  minmax(88px, 1.3fr)
  minmax(56px, 0.8fr)`;

/** Grid-template-columns constants for child (expanded) rows */
export const CHILD_COLUMNS_SINGLE = `
  minmax(70px, 0.95fr) minmax(64px, 0.9fr) minmax(42px, 0.7fr) minmax(72px, 1.2fr) minmax(64px, 1fr)
  minmax(54px, 0.8fr)
  minmax(44px, 0.65fr)
  minmax(72px, 1.1fr)
  minmax(48px, 0.7fr)
  minmax(64px, 1fr)
  minmax(52px, 0.8fr)
  repeat(2, minmax(64px, 1fr))
  minmax(54px, 0.8fr)`;

export const CHILD_COLUMNS_MULTI = `
  minmax(64px, 0.9fr) minmax(56px, 0.8fr) minmax(56px, 0.8fr) minmax(40px, 0.6fr) minmax(64px, 1fr) minmax(56px, 0.8fr)
  minmax(48px, 0.7fr)
  minmax(44px, 0.65fr)
  minmax(64px, 1fr)
  minmax(48px, 0.7fr)
  minmax(56px, 0.8fr)
  minmax(48px, 0.7fr)
  minmax(56px, 0.9fr)
  minmax(64px, 1fr)
  minmax(48px, 0.7fr)`;

/** Unified parent chain row — pass $columns to set grid layout */
export const ChainDashboardRow = styled(TableRow)<{
  tableBodyRow?: boolean;
  isExpanded?: boolean;
  $columns: string;
}>`
  grid-template-columns: ${({ $columns }) => $columns};
  min-height: ${({ tableBodyRow }) => (tableBodyRow ? 'auto' : '40px')};
  ${({ isExpanded, theme }) =>
    isExpanded
      ? `background-color: ${theme.color.paper}; border-bottom: none !important;`
      : ''}
`;

export const ChildTableWrapper = styled.div`
  background-color: ${({ theme }) => theme.color.backgroundDistinct};
  border: 1px solid ${({ theme }) => theme.color.border};
  margin: 0 4px 4px 4px;
  border-radius: 0 0 4px 4px;
  overflow: hidden;

  @media (max-width: 640px) {
    ${() => ChildHeaderRow} {
      padding: 0 4px;
    }

    ${() => ChildRow} {
      font-size: 0.5rem;
      padding-left: 4px;
      padding-right: 4px;
    }
  }
`;

/** Unified child header row — pass $columns to set grid layout */
export const ChildHeaderRow = styled.div<{ $columns: string }>`
  display: grid;
  grid-template-columns: ${({ $columns }) => $columns};
  background-color: ${({ theme }) => theme.color.paper};
  border-bottom: 1px solid ${({ theme }) => theme.color.border};
  padding: 0 8px;
`;

export const ChildHeaderCell = styled.div`
  font-size: 0.5rem;
  font-weight: 600;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color.labelText};
  padding: 6px 8px 6px 0;
  white-space: nowrap;

`;

/** Unified child row — pass $columns to set grid layout */
export const ChildRow = styled(TableRow)<{ tableBodyRow?: boolean; $columns: string }>`
  grid-template-columns: ${({ $columns }) => $columns};
  font-size: 0.65rem;
  padding-left: 8px;
  padding-right: 8px;
  white-space: nowrap;
  &:last-child {
    border-bottom: none;
  }
`;

export const ChevronButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.color.textSecondary};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 0.7rem;

  &:hover {
    color: ${({ theme }) => theme.color.textPrimary};
  }

  &:focus {
    outline: none;
  }
`;
